import LacunaWebPKI from "web-pki";

let webPkiLicense = 'AjQAYXBwLmlkdHJ1c3QuY29tLmJyLGZpbmFuNC5jb20uYnIsaWNjYi5pZHRydXN0LmNvbS5icnQAZmluYW40Lm5ldCxmaW5hbmZvci5hcHAsaXA0OjEwLjAuMC4wLzgsaXA0OjEyNy4wLjAuMC84LGlwNDoxNzIuMTYuMC4wLzEyLGlwNDoxOTIuMTY4LjAuMC8xNixwbGF5LWljY2IuaWR0cnVzdC5jb20uYnICAENBCAAA2IuBf5XeCAAByvmonEwsAGN5aVABdpQgadom1Y9+Hm2HWBuOSMBgDSDE4kaYvyRgtiHlQOtxSZM+Z7O2DfWNZFi2YF9HKNgctMFr8JLMTavd6jhacdUdLUZagfQdfDhmdi0ngXVoEmZDD96kGu6uhTKoNvr7dP3TuyTsPWXlNPZU7uGgDjlZ/XTYc1ePYrB9jD4LOd+16BOrkd2/7zrC+XaU5yk1T3+tEu13OE8cBm5bm9aZyZLL70QUs3LSMdyf7UG7eNs1GWQe8Zd61ie/9jajb7vHxJaZc8yh9UNHLCLixucT9OhbZuv9RX/p0aOlxi/1yYQLltjMERIz7a9sKNZRUbxQQknheA==';

export default {
  data() {
    return {
      pki: {},
      isExtensionInstalled: true,
      certificates: [],
      thumbprint: {}
    }
  },
  created: function () {
    this.pki = new LacunaWebPKI(webPkiLicense)
    this.pki.init({
      ready: this.onWebPkiReady,
      notInstalled: this.onWebPkiNotInstalled
    })
  },
  methods: {
    onWebPkiReady: function () {
      this.isExtensionInstalled = true
      this.loadCertificates()
    },
    loadCertificates() {
      this.pki.listCertificates().success(certs => {
        this.certificates = certs;
      })
    },
    readCertificate(thumbprint) {
      return this.pki.readCertificate(thumbprint)
    },
    onWebPkiNotInstalled: function () {
      this.isExtensionInstalled = false
    },
    redirectToInstallPage() {
      this.pki.redirectToInstallPage()
    }
  }
}
